import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export interface AuthState {
  authToken: string | null;
  isAuth: boolean;
}

const initialState: AuthState = {
  authToken:
    typeof window !== "undefined" ? Cookies.get("accessToken") || null : null,
  isAuth: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<{ authToken: string }>) => {
      state.authToken = action.payload.authToken;
      state.isAuth = true;

      // Set cookie for middleware access
      if (typeof window !== "undefined") {
        Cookies.set("accessToken", action.payload.authToken, {
          secure: process.env.NODE_ENV === "production",
          sameSite: "lax",
          expires: 7,
        });
      }
    },
    logout: (state) => {
      state.authToken = null;
      state.isAuth = false;

      if (typeof window !== "undefined") {
        Cookies.remove("accessToken");
      }
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
